(function () {
  var STORAGE_KEY = 'rb_age_verified';
  var DENY_URL = 'https://www.google.com/';
  var gate = document.getElementById('rb-age-gate');
  if (!gate) return;

  function verified() {
    try {
      return window.localStorage.getItem(STORAGE_KEY) === '1';
    } catch (err) {
      return false;
    }
  }

  function setVerified() {
    try {
      window.localStorage.setItem(STORAGE_KEY, '1');
    } catch (err) {
      /* ignore */
    }
  }

  function openGate() {
    gate.hidden = false;
    gate.removeAttribute('hidden');
    document.documentElement.classList.add('rb-age-gate-open');
    var accept = gate.querySelector('[data-rb-age-accept]');
    if (accept) window.setTimeout(function () { accept.focus(); }, 50);
  }

  function closeGate() {
    gate.hidden = true;
    gate.setAttribute('hidden', '');
    document.documentElement.classList.remove('rb-age-gate-open');
  }

  /*
   * Consentmo is only CSS-held while the age gate is open.
   * After closeGate(), do NOT call Consentmo.openDialog() — that re-opens
   * the notice after the visitor already accepted (seen as a double banner).
   * Consentmo shows itself when needed once the hold class is removed.
   */

  if (verified()) {
    closeGate();
    return;
  }

  openGate();

  var acceptBtn = gate.querySelector('[data-rb-age-accept]');
  var denyBtn = gate.querySelector('[data-rb-age-deny]');

  if (acceptBtn) {
    acceptBtn.addEventListener('click', function () {
      setVerified();
      closeGate();
    });
  }

  if (denyBtn) {
    denyBtn.addEventListener('click', function () {
      window.location.href = DENY_URL;
    });
  }

  /* Trap focus inside the dialog while open */
  gate.addEventListener('keydown', function (event) {
    if (event.key !== 'Tab') return;
    var focusable = gate.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });
})();
